(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdf-shop-the-drop"] && !Shopify.designMode) return;
  try {
    
  if (!window.pdfShopDropSwatchesBound) {
    window.pdfShopDropSwatchesBound = true;

    const normalizeShopDropCards = (root = document) => {
      root.querySelectorAll('.pdf-shop-drop .product-card').forEach((card) => {
        const title = card.querySelector('.product-card__title');
        const selectedSwatch =
          card.querySelector('color-swatch [aria-selected="true"]') ||
          card.querySelector('color-swatch [data-value]');
        if (!title || !selectedSwatch) return;

        const baseTitle = title.dataset.baseTitle || title.textContent.trim();
        title.dataset.baseTitle = baseTitle;
        title.textContent = baseTitle;

        let color = card.querySelector('.product-card__color');
        if (!color) {
          color = document.createElement('p');
          color.className = 'product-card__color';
          title.after(color);
        }
        color.textContent = selectedSwatch.dataset.value || '';
      });
    };

    normalizeShopDropCards();
    document.addEventListener('shopify:section:load', (event) => {
      normalizeShopDropCards(event.target);
    });

    const previewShopDropSwatch = (swatch) => {
      if (typeof window.updateProductCardFromSwatch === 'function') {
        window.updateProductCardFromSwatch(swatch);
      }
    };

    document.addEventListener('pointerover', (event) => {
      const swatch = event.target.closest('.pdf-shop-drop color-swatch [data-value]');
      if (!swatch || swatch.contains(event.relatedTarget)) return;
      previewShopDropSwatch(swatch);
    });

    document.addEventListener('focusin', (event) => {
      const swatch = event.target.closest('.pdf-shop-drop color-swatch [data-value]');
      if (swatch) previewShopDropSwatch(swatch);
    });

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('.pdf-shop-drop color-swatch [data-value]');
      if (!swatch) return;

      const variantUrl = swatch.dataset.variantUrl;
      if (variantUrl) window.location.assign(variantUrl);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
